import { useMemo, useState } from 'react'
import { Container, Reveal } from '@/components/common'
import type { Category } from '@/types/gallery'
import { shots, categories } from '@/constants/gallery'

export const GalleryGrid = () => {
  const [active, setActive] = useState<Category>('All')

  const visible = useMemo(
    () => (active === 'All' ? shots : shots.filter((shot) => shot.category === active)),
    [active],
  )

  return (
    <section className="bg-surface py-24 lg:py-32">
      <Container>
        {/* Filter tabs */}
        <Reveal variant="fade" duration={600}>
          <div className="flex flex-wrap gap-3">
            {categories.map((category) => (
              <button
                key={category}
                type="button"
                onClick={() => setActive(category)}
                aria-pressed={active === category}
                className={
                  active === category
                    ? 'rounded-full bg-ibon-dark px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors'
                    : 'rounded-full border border-border px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-text-muted transition-colors hover:border-ibon-sky hover:text-ibon-dark'
                }
              >
                {category}
              </button>
            ))}
          </div>
        </Reveal>

        {/* Masonry-style grid */}
        <div className="mt-12 grid auto-rows-[220px] grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 lg:gap-6">
          {visible.map((shot, index) => (
            <Reveal
              key={shot.caption}
              variant="zoom"
              delay={index * 50}
              className={shot.span ? 'row-span-2' : ''}
            >
              <figure className="group relative h-full w-full overflow-hidden">
                <img
                  src={shot.src}
                  alt={shot.caption}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-linear-to-t from-ibon-dark/80 via-ibon-dark/0 to-ibon-dark/0 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                <figcaption className="absolute inset-x-0 bottom-0 translate-y-2 p-5 text-sm font-semibold text-white opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                  {shot.caption}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}
